/** @deprecated Exported for testing purposes only */
export const usedIds = new Set<string>();

export const getUniqueLocalId = (): string => {
  let id: string;
  do {
    id = `local-${Math.random().toString(36).substr(2, 9)}`;
  } while (usedIds.has(id));

  usedIds.add(id);
  return id;
};
